<template>

  <div class="content">
    <div class="title">
      短信传情
    </div>
    <div class="main">
      <div class="card"
           style="background: rgb(255, 255, 255); border-radius: 15px; margin: 12px 0px; padding: 26px 32px;">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <span class="card-text1">你瞧</span>
          <span class="card-text" style="margin-left: 14px;">被人记起的感觉多么美好</span>
        </div>
        <div class="line-15"></div>
        <div class="card-text">至少在这个世界上</div>
        <div class="card-text">你能真真切切的想到我</div>
        <van-button color="#00D477" to="/write" class="card-btn" round type="primary">去发短信</van-button>

        <div class="card-img"></div>
      </div>

      <RgServiceCard
          title="人工传话"
          desc="由人工帮您给Ta代为传话，更有仪式感"
          btnText="去传话"
          @click="goMessenger('/messenger')"
      />


      <div class="combo-content">


      </div>
      <div class="service-btn" @click="showService">
        <van-icon name="service-o" class="service-icon"/>
        联系客服
      </div>


      <!--      <ComboRechargeItem-->
      <!--          avgPrice="1.0"-->
      <!--          num="15"-->
      <!--          tip="主流套餐"-->
      <!--          note="推荐！83.7%用户选择"-->
      <!--          price="1"/>-->
      <van-swipe v-if="bannerList != null" class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item @click="clickBanner(index)" v-for="(banner, index) in bannerList">
          <img :src="banner.bannerUrl" class="subscription-img">
        </van-swipe-item>
      </van-swipe>

    </div>
  </div>

  <!-- 客服弹窗 -->
  <van-popup 
    v-model:show="showServicePopup" 
    position="center" 
    round
    class="service-popup"
  >
    <div class="service-popup-content">
      <div class="service-popup-header">
        <h3 class="service-title">联系客服</h3>
        <van-icon name="cross" @click="showServicePopup = false" class="close-icon"/>
      </div>
      
      <div class="service-content">
        <div class="qr-container">
          <img src="@/assets/image/kf.jpg"
               alt="客服二维码" class="qr-code" />
        </div>
        
        <div class="tip-container">
          <p class="main-tip">💬 长按二维码添加客服微信</p>
        </div>
        
        <p class="work-time">🕒 工作时间：周一至周五 9:00-18:00</p>
        <p class="service-note">我们会尽快为您解答问题</p>
      </div>
      
      <div class="service-popup-footer">
        <van-button 
          type="primary" 
          color="#00D477" 
          round 
          block
          @click="showServicePopup = false"
        >
          知道了
        </van-button>
      </div>
    </div>
  </van-popup>

</template>

<script>
import {Button, Swipe, SwipeItem, ImagePreview, Icon, Popup} from 'vant';
import ComboRechargeItem from "../../components/ComboRechargeItem";
import {getJsAPiSign, getUserInfo, getHomeBanner} from "../../api/user";
import store from "../../store";
import RgServiceCard from '@/components/RgServiceCard.vue'
import wx from "weixin-js-sdk";

export default {
  name: "index",
  data() {
    return {
      clientHeight: '',
      bannerList: null,
      showBanner: false,
      showServicePopup: false,
    }
  },
  created() {
    // console.log(this.$route.query.channel)
    if (this.$route.query.channel)
      store.commit('setChannel', this.$route.query.channel)
    getUserInfo()

    getHomeBanner().then(res => {
      console.log(res.data.data)
      if (res.data.code === '00000'){
        this.bannerList = res.data.data
      }
    })
    // let url = {'url': window.location.href}
    // getJsAPiSign(url)
    //     .then(res => {
    //       wx.config({
    //         debug: false, // 开启调试模式,
    //         appId: res.data.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
    //         timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
    //         nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
    //         signature: res.data.data.signature,// 必填，签名，见附录1
    //         jsApiList: [], // 必填，需要使用的JS接口列表，所有JS接口列
    //         openTagList: ['wx-open-launch-weapp']
    //       });
    //     })
  },
  methods: {
    toSubscription() {
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3NDc1MzU5OA==#wechat_redirect'
    },
    goMessenger(path) {
      this.$router.push({
        path: path
      })
    },
    clickBanner(e) {
      let banner = this.bannerList[e]
      switch (banner.jumpType){
        case 0:
          break;
        case 1:
          ImagePreview.show({
            images: [banner.paramsData],
            startPosition: 0
          });
          break;
        case 2:
          window.location.href = banner.paramsData
          break;
        case 3:
          break;
        default:
          break;
      }
      console.log(e)
    },
    showService() {
      this.showServicePopup = true;
    }
  },
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    ComboRechargeItem,
    RgServiceCard,
  },


}
</script>

<style scoped>
.content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.main {
  background: #f7f7f7;
  /*padding: 0 15px ;*/
  padding: 0 15px 65px 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}


.title {
  font-size: 22px;
  color: #292833;
  font-weight: bold;
  height: 40px;
  padding: 15px;
  line-height: 40px;
  z-index: 999;
  background: #f7f7f7;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.line-15 {
  height: 15px;
}


.card-text {
  box-sizing: border-box;
  display: block;
  font-size: 14px;
  white-space: pre-wrap;
}

.card-text1 {
  box-sizing: border-box;
  display: block;
  white-space: pre-wrap;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  border-radius: 2px;
  color: #292833;
  background: #f1f1f1;
  width: 40px;
}

.card-btn {
  width: 140px;
  height: 40px;
  margin-top: 30px;
}

.card-img {
  height: 130px;
  background: url('../../assets/image/01.png') right center / contain no-repeat;
  margin-top: -80px;
}

.card {
  align-content: flex-start;
  border: 0 solid #000;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 0;
  background: rgb(255, 255, 255);
  border-radius: 15px;
  margin: 12px 0px;
  padding: 26px 32px;
}

.combo-content {
  flex: 1;
}
.my-swipe{
  box-sizing: border-box;
  width: 345px;
}

.subscription-img {
  width: 345px;
  height: 100px;
  float: bottom;
}

/* 客服按钮样式 */
.service-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 30px);
  max-width: calc(100vw - 30px);
  margin: 20px auto;
  padding: 15px 24px;
  background: linear-gradient(135deg, #00D477 0%, #00b96b 100%);
  color: white;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 6px 20px rgba(0, 212, 119, 0.3);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border: none;
  outline: none;
}

.service-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s;
}

.service-btn:hover::before {
  left: 100%;
}

.service-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 212, 119, 0.4);
  background: linear-gradient(135deg, #00e685 0%, #00c96a 100%);
}

.service-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 212, 119, 0.3);
  transition: all 0.1s;
}

.service-icon {
  margin-right: 10px;
  font-size: 18px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* 客服弹窗样式 */
.service-popup {
  max-width: 90vw;
  border-radius: 16px;
  overflow: hidden;
}

.service-popup-content {
  background: white;
  box-sizing: border-box;
  width: 320px;
}

.service-popup-header {
  background: linear-gradient(135deg, #00D477 0%, #00b96b 100%);
  color: white;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.service-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-icon {
  font-size: 18px;
  cursor: pointer;
  color: white;
}

.service-content {
  padding: 20px;
  text-align: center;
}

.qr-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 8px;
  border-radius: 12px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-code {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  border: 2px solid #00D477;
  box-shadow: 0 2px 8px rgba(0, 212, 119, 0.2);
  display: block;
}

.tip-container {
  background: rgba(0, 212, 119, 0.1);
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.main-tip {
  color: #00D477;
  font-size: 14px;
  margin: 0;
  font-weight: 600;
}

.work-time {
  color: #666;
  font-size: 12px;
  margin: 0 0 10px 0;
}

.service-note {
  color: #999;
  font-size: 11px;
  margin: 0;
}

.service-popup-footer {
  padding: 16px 20px;
  background: #f8f9fa;
}

.service-popup-footer .van-button {
  height: 40px;
  font-weight: 600;
}


</style>